<template>
  <div>
    <span class="eh-page-title">{{ title }}</span>
    <employee-hub-bookmark
      id="bookmark"
      :title="title"
      :env="env"
      class="ml-2"
    />
  </div>
</template>

<script>
export default {
  name: "title-with-bookmark",
  props: ["title"],
  data() {
    return {
      env: CURRENT_ENV
    }
  }
};
</script>
